import { Suspense, lazy } from "react";
import { useTpsConnectDialog } from "@/lib/tpsConnect";

const TPSConnectDialog = lazy(() => import("./TPSConnectDialog"));

/** Mounted once inside the router; `openTpsConnect()` shows the dialog from anywhere. */
export function TPSConnectDialogHost() {
  const [open, setOpen] = useTpsConnectDialog();
  if (!open) return null;
  return (
    <Suspense fallback={null}>
      <TPSConnectDialog open onOpenChange={setOpen} />
    </Suspense>
  );
}
